<template>
  <div>
    <v-overlay
      :color="$vuetify.theme.isDark ? 'black' : 'white'"
      opacity="0.9"
      absolute
      v-if="$store.state.momo.progress"
    >
      <center v-if="!$store.state.momo.requestPendding">
        <v-progress-circular
          :color="$vuetify.theme.isDark ? 'white' : 'blue darken-4'"
          size="50"
          width="4"
          indeterminate
        >
        </v-progress-circular>

        <strong :class="$vuetify.theme.isDark ? 'white--text' : 'black--text'"
          >Transaction in progress, do not close this dialog or page</strong
        >
      </center>
      <center v-else>
        <h4 v-if="network == 'MTN'" class="yellow--text font-weight-bold">
          Dial *170#
        </h4>
        <h4 v-if="network == 'MTN'" class="yellow--text font-weight-bold">
          Select 6 - My Wallet
        </h4>
        <h4 v-if="network == 'MTN'" class="yellow--text font-weight-bold">
          Select 3 - My Approvals
        </h4>

        <v-progress-circular
          :color="$vuetify.theme.isDark ? 'white' : 'blue darken-4'"
          size="30"
          width="4"
          indeterminate
        >
        </v-progress-circular>
        <br />

        <strong :class="$vuetify.theme.isDark ? 'white--text' : 'black--text'"
          >Waiting for payment authorisation, <br />
          transaction would continue automatically
        </strong>

        <v-btn
          class="d-block mt-5"
          rounded
          outlined
          color="red"
          v-if="business.country.code === 'RW'"
          @click="
            clearPaymentPoll();
            $store.state.momo.progress = false;
          "
          >Cancel
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </center>
    </v-overlay>

    <v-card-text v-if="business.country.code === 'GH'">
      <v-sheet
        v-if="costBreakdown"
        color="grey lighten-5"
        rounded="lg"
        elevation="0"
        class="pa-4 mb-4 text-left"
      >
        <div class="d-flex justify-space-between py-1 body-2">
          <span>Subscription base (before taxes)</span>
          <strong>{{ costBreakdown.base | toMoney | currency_symbol }}</strong>
        </div>
        <div class="d-flex justify-space-between py-1 text--secondary caption">
          <span>VAT (15%)</span>
          <span>{{ costBreakdown.vat | toMoney | currency_symbol }}</span>
        </div>
        <div class="d-flex justify-space-between py-1 text--secondary caption">
          <span>NHIL (2.5%)</span>
          <span>{{ costBreakdown.nhil | toMoney | currency_symbol }}</span>
        </div>
        <div class="d-flex justify-space-between py-1 text--secondary caption">
          <span>GETFund levy (2.5%)</span>
          <span>{{ costBreakdown.getfund | toMoney | currency_symbol }}</span>
        </div>
        <v-divider class="my-2"></v-divider>
        <div
          class="d-flex justify-space-between text-h6 primary--text font-weight-bold"
        >
          <span>Total to pay</span>
          <span>{{ costBreakdown.total | toMoney | currency_symbol }}</span>
        </div>
      </v-sheet>

      <v-stepper class="p-0" v-model="step" style="box-shadow: none !important">
        <v-stepper-items>
          <v-stepper-content step="1" class="p-0">
            <v-row dense>
              <v-col cols="12" class="mt-2">
                <v-select
                  :items="networks"
                  label="Select Network Operator"
                  v-model="network"
                  outlined
                  :disabled="$store.state.momo.progress"
                >
                  <template v-slot:item="{ item }">
                    <v-list-item-avatar>
                      <v-img
                        :src="'/img/icons/' + item.value + '.jpeg'"
                      ></v-img>
                    </v-list-item-avatar>
                    {{ item.text }}
                  </template>

                  <template v-slot:prepend-inner>
                    <v-avatar size="30" class="m-2 mb-5">
                      <v-img :src="selectedIcon"></v-img>
                    </v-avatar>
                  </template>
                </v-select>
              </v-col>

              <v-col cols="12">
                <v-text-field
                  placeholder="024xxxxxxx"
                  type="tel"
                  v-if="network"
                  label="Phone Number"
                  v-model="number"
                  outlined
                  :disabled="$store.state.momo.progress"
                ></v-text-field>
              </v-col>

              <v-col class="12">
                <v-alert
                  v-if="false"
                  type="error"
                  color="red lighten-5 red--text"
                  class="font-weight-light"
                >
                  The amount has exceeded the limit, you cannot send more than
                  GHS5,000.
                </v-alert>

                <v-btn
                  depressed
                  block
                  dark
                  color="blue darken-4"
                  rounded
                  :loading="progress"
                  large
                  v-if="validMOMO && !$store.state.momo.requestPendding"
                  @click="pay"
                  >Pay Now!
                </v-btn>
              </v-col>
            </v-row>
          </v-stepper-content>
          <v-stepper-content step="2" class="p-0">
            <v-row dense>
              <v-col cols="12" sm="12" class="mx-auto text-center">
                <h4>
                  Please enter OTP code sent to
                  <strong
                    >******{{ number.substring(number.length, 6) }}</strong
                  >
                  to continue
                </h4>
                <span
                  >Did not get code?
                  <v-btn
                    text
                    color="blue"
                    x-small
                    rounded
                    @click="
                      sendOTP();
                      new_request = !new_request;
                    "
                    :loading="progress"
                    >request new code</v-btn
                  >
                  or
                  <v-btn text color="blue" x-small @click="step = 1"
                    >change number</v-btn
                  >
                </span>
                <v-alert
                  v-if="new_request && !progress"
                  type="success"
                  color="green lighten-5 green--text"
                  dismissible
                  class="p-1"
                >
                  <h5>New OTP Sent</h5>
                </v-alert>
              </v-col>
              <v-col cols="12" sm="8" class="mx-auto text-center">
                <v-progress-circular
                  size="40"
                  color="blue darken-4"
                  indeterminate
                  v-if="verifyingOTP"
                ></v-progress-circular>
                <v-otp-input
                  v-else
                  ref="otpInput"
                  input-classes="form-control border"
                  separator="&nbsp;"
                  :num-inputs="6"
                  :should-auto-focus="true"
                  :is-input-num="true"
                  @on-change="handleOTPChange"
                  @on-complete="handleOTPComplete"
                />
              </v-col>
            </v-row>
          </v-stepper-content>
        </v-stepper-items>
      </v-stepper>
    </v-card-text>

    <v-card-text v-if="business.country.code === 'KE'">
      <center>
        <h1 class="font-weight-black mb-0 pb-0">
          {{ resolvedPayableAmount | toMoney | currency_symbol }}
        </h1>
        <small class="text-muted mb-3">Amount Due</small>
      </center>

      <v-form ref="KEcheckoutForm">
        <v-text-field
          placeholder="254xxxxxxxxx"
          type="tel"
          label="Phone Number"
          v-model="numberKE"
          :rules="$store.state.requiredRule"
          outlined
          :disabled="$store.state.momo.progress"
        ></v-text-field>

        <v-btn
          depressed
          block
          dark
          color="blue darken-4"
          rounded
          :loading="progress"
          x-large
          @click="KEMOMOpay"
          >Pay Now!
        </v-btn>
      </v-form>
    </v-card-text>
    <v-card-text v-if="business.country.code === 'RW'">
      <center>
        <h1 class="font-weight-black mb-0 pb-0">
          {{ resolvedPayableAmount | toMoney | currency_symbol }}
        </h1>
        <small class="text-muted mb-3">Amount Due</small>
      </center>

      <v-form ref="RWcheckoutForm">
        <v-text-field
          placeholder="07########"
          type="tel"
          label="Phone Number"
          v-model="numberKE"
          :rules="$store.state.requiredRule"
          outlined
          :disabled="$store.state.momo.progress"
        ></v-text-field>

        <v-btn
          depressed
          block
          dark
          color="blue darken-4"
          rounded
          :loading="progress"
          x-large
          @click="RWMOMOpay"
          >Pay Now!
        </v-btn>
      </v-form>
    </v-card-text>

    <v-card-text v-if="business.country.code === 'SL'">
      <center>
        <v-avatar size="120" rounded>
          <v-img
            src="https://built-storage.ams3.cdn.digitaloceanspaces.com/Built/logo_orange.svg"
            contain
          ></v-img>
        </v-avatar>
      </center>
      <h2 class="text-center">Pay with Orange money</h2>
      <p class="text-h4 text-center font-weight-light">
        {{ resolvedPayableAmount | toMoney | currency_symbol }}
        <small class="text-small d-block">Amount</small>
      </p>

      <v-alert color="orange lighten-5 orange--text">
        <strong
          >How to get the payment code when you get to the payment page:</strong
        >
        <ul class="mt-3">
          <li>Dial *144#</li>
          <li>Select Make Payment</li>
          <li>Select Online Payment</li>
          <li>Confirm your PIN</li>
          <li>The payment security code would be sent to your phone</li>
        </ul>
      </v-alert>

      <v-btn
        :loading="progress"
        @click="getOrangeCheckout"
        color="orange darken-2"
        x-large
        rounded
        block
        dark
        depressed
        >Pay Now!
      </v-btn>
    </v-card-text>

    <v-dialog persistent width="500" v-model="$store.state.momo.failed">
      <v-card>
        <v-card-title class="font-weight-light">
          Transaction failed
        </v-card-title>
        <v-card-text>
          <h4 class="font-weight-light">{{ $store.state.momo.message }}</h4>
        </v-card-text>
        <v-card-actions>
          <v-btn
            color="red"
            block
            depressed
            rounded
            dark
            x-large
            @click="
              clearPaymentPoll();
              $store.state.momo.requestPendding = false;
              $store.state.momo.progress = false;
              $store.state.momo.failed = false;
            "
            >{{ $t("main.ok") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  name: "Checkout",
  emits: ["paymentComplete"],
  props: {
    amount: {},
    account_id: {},
    record_type: {
      type: String,
    },
    record_id: {},
    metaData: {},
    isEligibleForDiscount: {
      type: Boolean,
      default: false,
    },
    discountedPrice: {},
    /** When set (e.g. Ghana subscription), shows VAT / NHIL / GETFund lines before MoMo steps. */
    costBreakdown: {
      type: Object,
      default: null,
    },
    extraPropKey: {
      type: String,
    },
    extraPropValue: {},
    /** Sent as `coupon` on `/api/init-momo-subscription` when paying a subscription (record_type subscription-*). */
    momoSubscriptionCoupon: {
      type: String,
      default: "",
    },
  },

  data() {
    return {
      userOTP: null,
      verifyingOTP: false,
      new_request: false,
      otp: null,
      step: 1,
      requestPendding: false,
      network: null,
      number: "",
      progress: false,
      ref: "",
      failed: false,
      failed_meesage: "",
      numberKE: "",
      paymentPollTimeout: null,
      paymentResolved: false,
      networks: [
        {
          text: "AirtelTigo",
          value: "AirtelTigo",
        },
        {
          text: "MTN",
          value: "MTN",
        },
        {
          text: "Vodafone",
          value: "VODAFONE",
        },
      ],

      numberPattern: [
        {
          network: "MTN",
          code: "024",
        },

        {
          network: "MTN",
          code: "055",
        },
        {
          network: "MTN",
          code: "054",
        },

        {
          network: "MTN",
          code: "059",
        },

        {
          network: "VODAFONE",
          code: "020",
        },

        {
          network: "VODAFONE",
          code: "050",
        },

        {
          network: "AIRTEL",
          code: "027",
        },

        {
          network: "AIRTEL",
          code: "057",
        },

        {
          network: "AIRTEL",
          code: "026",
        },
      ],
    };
  },
  watch: {
    complete() {
      this.step = 1;
      this.verifyingOTP = false;
    },
  },
  computed: {
    reference() {
      let text = "";
      let possible =
        "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
      for (let i = 0; i < 10; i++)
        text += possible.charAt(Math.floor(Math.random() * possible.length));
      let d = new Date();
      let timestamp = d.getTime();
      return "Subscription_" + timestamp + "" + text;
    },
    business() {
      return this.$store.state.user.user_infor.current_business;
    },

    resolvedPayableAmount() {
      if (
        this.isEligibleForDiscount &&
        this.discountedPrice != null &&
        this.discountedPrice !== ""
      ) {
        const d = Number(this.discountedPrice);
        if (!Number.isNaN(d) && d >= 0) {
          return d;
        }
      }
      const a = Number(this.amount);
      return Number.isNaN(a) ? 0 : a;
    },

    complete() {
      return this.$store.state.momo.complete2;
    },

    validMOMO() {
      return this.network && this.number.length === 10 && !isNaN(this.number);
    },

    /**
     * @return {boolean}
     */
    NumberBelongsToNetwork() {
      let network = this.network;
      let code = this.number.substring(0, 3);

      const foundNetwork = this.numberPattern.find((item) => {
        return item.code === code && item.network === network;
      });

      return Boolean(foundNetwork);
    },

    selectedIcon() {
      return this.network
        ? "/img/icons/" + this.network + ".jpeg"
        : "/img/icons/cellphone-message.png";
    },

    isMomoSubscription() {
      return (
        typeof this.record_type === "string" &&
        this.record_type.startsWith("subscription-")
      );
    },
  },
  methods: {
    momoSubscriptionPlanName() {
      if (!this.isMomoSubscription) return "";
      return this.record_type.slice("subscription-".length);
    },

    momoSubscriptionInterval() {
      const n = Number(this.record_id);
      return Number.isFinite(n) && n > 0 ? n : 1;
    },

    momoSubscriptionApiNetwork() {
      const code = this.business.country.code;
      if (code === "KE") return "mpesa";
      if (code === "SL") return "orange_money";
      if (code === "RW") return "MTN";
      if (!this.network) return "MTN";
      if (this.network === "AirtelTigo") return "AIRTELTIGO";
      return String(this.network).toUpperCase();
    },

    buildMomoSubscriptionBody() {
      let current_plan_id = "";
      let change_current_plan_id = "";
      if (this.extraPropKey === "current_plan_id") {
        current_plan_id =
          this.extraPropValue != null ? String(this.extraPropValue) : "";
      }
      if (this.extraPropKey === "change_current_plan_id") {
        change_current_plan_id =
          this.extraPropValue != null ? String(this.extraPropValue) : "";
      }

      let account_number = "";
      if (this.business.country.code === "GH") {
        account_number = (this.number || "").replace(/\D/g, "");
      } else if (
        this.business.country.code === "KE" ||
        this.business.country.code === "RW"
      ) {
        account_number = (this.numberKE || "").replace(/\D/g, "");
      }

      return {
        network: this.momoSubscriptionApiNetwork(),
        interval: this.momoSubscriptionInterval(),
        plan_name: this.momoSubscriptionPlanName(),
        account_number,
        coupon:
          this.momoSubscriptionCoupon != null
            ? String(this.momoSubscriptionCoupon)
            : "",
        current_plan_id,
        change_current_plan_id,
      };
    },

    submitMomoSubscriptionPayment() {
      localStorage.setItem("showOfferDialog", "false");
      this.$store.state.momo.progress = true;
      this.progress = true;

      axios
        .post("/api/init-momo-subscription", this.buildMomoSubscriptionBody())
        .then((res) => {
          const d = res.data || {};

          if (d.payment_url) {
            this.$store.state.momo.progress = false;
            this.progress = false;
            window.location.href = d.payment_url;
            return;
          }

          if (d.reference) {
            this.ref = d.reference;
            this.$store.state.momo.requestPendding = true;
            this.listenForAuth();
            return;
          }
          this.$store.state.momo.progress = false;
          this.progress = false;
          this.$store.state.momo.message = d.msg || "Something went wrong";
          this.$store.state.momo.failed = true;
        })
        .catch((error) => {
          this.$store.state.momo.progress = false;
          this.progress = false;
          const body = error.response && error.response.data;
          const msg = body && (body.msg || body.message);
          if (msg) {
            this.$store.state.momo.message = msg;
            this.$store.state.momo.failed = true;
          }
        });
    },

    getOrangeCheckout() {
      if (this.isMomoSubscription) {
        this.submitMomoSubscriptionPayment();
        return;
      }

      this.progress = true;

      let data = {
        amount: this.resolvedPayableAmount,
        account_id: this.account_id,
        record_type: this.record_type,
        record_id: this.record_id,
        reference: this.reference,
      };

      if (this.extraPropKey && this.extraPropValue) {
        data[this.extraPropKey] = this.extraPropValue;
      }

      axios
        .post("/api/orange/init/checkout", data)
        .then((res) => {
          if (res.data && res.data.status == 201 && res.data.payment_url) {
            window.open(res.data.payment_url);
          }
          this.progress = false;
        })
        .catch((error) => {
          this.progress = false;
        });
    },
    KEMOMOpay() {
      if (this.$refs.KEcheckoutForm.validate()) {
        if (this.isMomoSubscription) {
          this.submitMomoSubscriptionPayment();
          return;
        }

        this.$store.state.momo.progress = true;

        const formData = new FormData();
        formData.append("phone_number", this.numberKE);
        formData.append("amount", this.resolvedPayableAmount);
        formData.append("account_number", this.numberKE);
        formData.append("account_id", this.account_id);
        formData.append("reference", this.reference);

        if (this.record_id && this.record_type) {
          formData.append("record_type", this.record_type);
          formData.append("record_id", this.record_id);
        }

        if (this.metaData) {
          formData.append("meta_data", this.metaData);
        }

        if (this.extraPropKey && this.extraPropValue) {
          formData.append(this.extraPropKey, this.extraPropValue);
        }

        let oldULR = "/api/ke/init/mobile-checkout";
        oldULR = "/api/collection/mpesa";
        axios
          .post(oldULR, formData)
          .then((res) => {
            const ch = "TANDA-MPESA_" + res.data.id;

            if (res.data.status === "000001") {
              this.ref = res.data.id;

              this.listenForMPesaAuth(ch);

              this.$store.state.momo.requestPendding = true;
            } else {
              this.$store.state.momo.progress = false;
              this.$store.state.momo.message = res.data.message;
              this.$store.state.momo.failed = true;
            }
          })
          .catch((error) => {
            this.$store.state.momo.progress = false;
          });
      }
    },

    RWMOMOpay() {
      if (this.$refs.RWcheckoutForm.validate()) {
        if (this.isMomoSubscription) {
          this.submitMomoSubscriptionPayment();
          return;
        }

        this.$store.state.momo.progress = true;

        const formData = new FormData();
        formData.append("phone_number", this.numberKE);
        formData.append("amount", this.resolvedPayableAmount);
        formData.append("account_number", this.numberKE);
        formData.append("account_id", this.account_id);
        formData.append("reference", this.reference);

        if (this.record_id && this.record_type) {
          formData.append("record_type", this.record_type);
          formData.append("record_id", this.record_id);
        }

        if (this.metaData) {
          formData.append("meta_data", this.metaData);
        }

        if (this.extraPropKey && this.extraPropValue) {
          formData.append(this.extraPropKey, this.extraPropValue);
        }

        const URL = "/api/rw/init/mobile-checkout";

        axios
          .post(URL, formData)
          .then((res) => {
            const ch = "PAYPACK_" + res.data.ref;

            if (res.data.status.toUpperCase() === "PENDING") {
              this.ref = res.data.ref;

              this.listenForAuth(ch);

              this.$store.state.momo.requestPendding = true;
            } else {
              this.$store.state.momo.progress = false;
              this.$store.state.momo.message = res.data.message;
              this.$store.state.momo.failed = true;
            }
          })
          .catch((error) => {
            this.$store.state.momo.progress = false;
            // this.$store.state.momo.message =
            //     error.response.status === 302
            //         ? error.response.data
            //         : "Something went wrong, please try again";
            // this.$store.state.momo.failed = true;
          });
      }
    },
    handleOTPChange() {},

    handleOTPComplete(otp) {
      this.userOTP = otp;
      this.veirifyOTP();
    },

    handleClearOTP() {},

    veirifyOTP() {
      this.verifyingOTP = true;
      const formData = new FormData();
      formData.append("id", this.otp.id);
      formData.append("phone_number", this.otp.recipient_number);
      axios
        .post("/api/otp/verify/" + this.userOTP, formData)
        .then((res) => {
          this.verifyingOTP = false;
          this.otp = res.data;
          if (res.data.status) {
            this.pay();
          } else {
            this.$store.state.momo.message = res.data.message;
            this.$store.state.momo.failed = true;
          }
        })
        .catch((error) => {
          this.verifyingOTP = false;
          // this.$store.state.momo.message =
          //     "Something went wrong, could not verify the OTP code;";
          // this.$store.state.momo.failed = true;
        });
    },

    sendOTP() {
      this.progress = true;

      if (this.number) {
        axios
          .get("/api/otp/code/" + this.number)
          .then((res) => {
            this.otp = res.data;

            this.progress = false;

            if (res.data.status) {
              this.step = 2;
            } else {
              this.$store.state.momo.message = res.data.message;
              this.$store.state.momo.failed = true;
            }
          })
          .catch((error) => {
            this.progress = false;

            // this.$store.state.momo.message =
            //     "Something went wrong, could not send OTP";
            // this.$store.state.momo.failed = true;
          });
      }
    },

    pay() {
      if (this.isMomoSubscription) {
        this.submitMomoSubscriptionPayment();
        return;
      }

      this.$store.state.momo.progress = true;

      let formData = new FormData();

      formData.append("network", this.network);
      formData.append("account_number", this.number);
      formData.append("amount", this.resolvedPayableAmount);

      formData.append("account_id", this.account_id);

      if (this.record_id && this.record_type) {
        formData.append("record_type", this.record_type);
        formData.append("record_id", this.record_id);
      }

      localStorage.setItem("showOfferDialog", "false");

      //formData.append('otp_id',this.otp.id);

      if (this.extraPropKey && this.extraPropValue) {
        formData.append(this.extraPropKey, this.extraPropValue);
      }

      axios
        .post("/api/nsano/debit", formData)
        .then((res) => {
          const trans = res.data || {};

          if (trans.code === "00" && trans.reference) {
            this.ref = trans.reference;
            this.$store.state.momo.requestPendding = true;
            this.listenForAuth("debitconfirmation_" + trans.reference);
            return;
          }

          this.$store.state.momo.progress = false;
          this.$store.state.momo.message =
            trans.msg || "Something went wrong, please try again";
          this.$store.state.momo.failed = true;
        })
        .catch(() => {
          this.$store.state.momo.progress = false;
        });
    },

    clearPaymentPoll() {
      if (this.paymentPollTimeout) {
        clearTimeout(this.paymentPollTimeout);
        this.paymentPollTimeout = null;
      }
    },

    scheduleMomoPollRetry(attempt) {
      const nextAttempt = attempt + 1;
      if (nextAttempt >= 5) return;

      const delay = 5000 * Math.pow(2, attempt);
      this.paymentPollTimeout = setTimeout(() => {
        this.pollMomoTransactionForCompletion(nextAttempt);
      }, delay);
    },

    handlePaymentSuccess() {
      // Emit first so parents can switch to a success view before the
      // progress overlay clears (otherwise the Pay Now form flashes).
      this.$emit("paymentComplete", {
        ref: this.ref,
        account_id: this.account_id,
        amount: this.resolvedPayableAmount,
      });
      this.$store.state.momo.requestPendding = false;
      this.$store.state.momo.complete2 = !this.$store.state.momo.complete2;
      this.$store.state.momo.progress = false;
      this.progress = false;
    },

    handlePaymentFailure(message) {
      this.paymentResolved = true;
      this.clearPaymentPoll();
      this.$store.state.momo.message =
        message || "Payment failed, please try again";
      this.$store.state.momo.failed = true;
      this.$store.state.momo.progress = false;
      this.$store.state.momo.requestPendding = false;
    },

    pollMomoTransactionForCompletion(attempt) {
      if (this.paymentResolved || !this.$store.state.momo.progress) return;
      if (attempt >= 5) return;
      if (!this.ref) return;

      axios
        .get("/api/bw/momo-transaction/" + this.ref)
        .then((res) => {
          if (this.paymentResolved || !this.$store.state.momo.progress) return;

          const tx = res.data && res.data.data;
          const code = tx && String(tx.code);

          if (code === "00") {
            this.paymentResolved = true;
            this.clearPaymentPoll();
            this.handlePaymentSuccess();
            return;
          }

          if (code === "01" || !code) {
            this.scheduleMomoPollRetry(attempt);
            return;
          }

          this.handlePaymentFailure(
            (tx && (tx.msg || tx.message)) || "Payment failed, please try again"
          );
        })
        .catch(() => {
          if (this.paymentResolved || !this.$store.state.momo.progress) return;
          this.scheduleMomoPollRetry(attempt);
        });
    },

    resolveDebitSocketPayload(e) {
      if (!e || typeof e !== "object") return {};

      // Actual socket shape:
      // { message: "PAID BY CLIENT", data: { code: "00", payload: {...}, reference } }
      if (e.data && typeof e.data === "object" && e.data.code != null) {
        return e.data;
      }
      if (e.message && typeof e.message === "object" && e.message.code != null) {
        return e.message;
      }
      if (e.code != null) return e;
      if (e.data && typeof e.data === "object") return e.data;
      return {};
    },

    listenForAuth(ch = null) {
      const channel = ch ? ch : `debitconfirmation_${this.ref}`;

      this.clearPaymentPoll();
      this.paymentResolved = false;

      this.sockets.subscribe(channel, (e) => {
        if (this.paymentResolved) return;

        console.log("sucess")
        const payload = this.resolveDebitSocketPayload(e);
        const code = payload.code != null ? String(payload.code) : "";

        if (code === "01" || !code) {
          return;
        }

        if (code === "00") {
          this.paymentResolved = true;
          this.clearPaymentPoll();
          this.handlePaymentSuccess();
          return;
        }

        this.handlePaymentFailure(
          (payload.system_msg && payload.system_msg.length > 0
            ? payload.system_msg
            : payload.error_message || payload.msg) ||
            "Payment failed, please try again"
        );
      });

      this.paymentPollTimeout = setTimeout(() => {
        this.pollMomoTransactionForCompletion(0);
      }, 30000);
    },

    listenForMPesaAuth(ch = null) {
      const channel = ch ? ch : `debitconfirmation_${this.ref}`;

      this.clearPaymentPoll();
      this.paymentResolved = false;

      this.sockets.subscribe(channel, (e) => {
        if (this.paymentResolved) return;

        const payload = this.resolveDebitSocketPayload(e);

        if (payload.status && payload.status !== "000000") {
          this.handlePaymentFailure(
            (payload.system_msg && payload.system_msg.length > 0
              ? payload.system_msg
              : payload.error_message) || "Payment failed, please try again"
          );
          return;
        }

        if (payload.status === "000000") {
          this.paymentResolved = true;
          this.clearPaymentPoll();
          this.handlePaymentSuccess();
        }
      });

      this.paymentPollTimeout = setTimeout(() => {
        this.pollMomoTransactionForCompletion(0);
      }, 30000);
    },
  },
  beforeDestroy() {
    this.clearPaymentPoll();
  },
};
</script>

<style scoped></style>
